module.exports = __webpack_public_path__ + "static/media/remolino-ventacruzada-horizontal.bbc902ca.jpg";